import { render, staticRenderFns } from "./DocumentPositionSearch.vue?vue&type=template&id=16eb43f8&"
import script from "./DocumentPositionSearch.vue?vue&type=script&lang=js&"
export * from "./DocumentPositionSearch.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports